module.exports = __webpack_public_path__ + "static/media/dashbord-icon-team-accepted.48c10257.png";